import request from '@/system/engine/request.js';
import config from '@/system/engine/config.js';
import { ElMessageBox } from 'element-plus';
import {getItem,setItem,removeItem} from '@/system/store/localstorage.js';
import axios from 'axios';

export default{
    install: (app) => {
        app.config.globalProperties.$m = {
            postMethod(url,postData){
                const data = request({
                    url: config.url+url,
                    method: 'post',
                    data: postData
                });
                
                return Promise.resolve(data);
            },getItem(name){
                return getItem(name);
            },setItem(name,value){
                return setItem(name,value);
            },removeItem(name){
                return removeItem(name);
            },genRandomCode(number){
                let text = "";
                let chars = "abcdefghijklmnopqrstuvwxyz123456789";
                
                for( let i=0; i < number; i++ ) {
                    text += chars.charAt(Math.floor(Math.random() * chars.length));
                }

                return text.toUpperCase();
            },genRandomSerialCode(number){
                let text = "";
                let chars = "0123456789";
                
                for( let i=0; i < number; i++ ) {
                    text += chars.charAt(Math.floor(Math.random() * chars.length));
                }

                return text;
            },openBrowser(url){
                if(url.includes('http')){
                    window.open(url, "_blank");  
                }
            },popupErrorMessage(returnMsg,self){
                var text = '';

                returnMsg.forEach(function (value){
                    text+= value+"<br/>";
                });
                
                ElMessageBox.alert(text, 'Error', {
                    type: 'error',
                    dangerouslyUseHTMLString: true
                });
                
            },popupInfoMessage(returnMsg,self){
                var text = '';

                returnMsg.forEach(function (value){
                    text+= value+"<br/>";
                });
                
                ElMessageBox.alert(text, 'Guide', {
                    dangerouslyUseHTMLString: true
                });
                
            },popupSingleErrorMessage(returnMsg,self){
                ElMessageBox.alert(returnMsg, 'Error', {
                    type: 'error',
                    dangerouslyUseHTMLString: true
                });
                
            },settingSidebar(){
                var sidebar = document.getElementById('main-container');
                if(sidebar.className.includes('openSettingSideBar')){
                    sidebar.classList.remove("openSettingSideBar");
                }else{
                    sidebar.className += " openSettingSideBar";
                }
            },htmlDecoder (str) {
                str = str.replace(/&quot;/g,"'");
                var textArea = document.createElement('textarea');
                textArea.innerHTML = str;

                return textArea.value;
            },backToTop(){
                var isMoving = false;
                var interval;

                if (isMoving) return;
                const start = window.pageYOffset;
                let i = 0;
                isMoving = true;
                interval = setInterval(() => {
                    const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500));
                    if (next <= 0) {
                        window.scrollTo(0, 0);
                        clearInterval(interval)
                        isMoving = false;
                    } else {
                        window.scrollTo(0, next);
                    }
                    i++;
                }, 16.7);
            },easeInOutQuad(t, b, c, d) {
                if ((t /= d / 2) < 1) return c / 2 * t * t + b;
                return -c / 2 * (--t * (t - 2) - 1) + b;
            },removeCommonLocalStorage(){
                removeItem('authSignToken');
                removeItem('appVersion');
                removeItem('languageList');
                removeItem('permissionList');
            },telebot(text){
                var botApi = '1379716596:AAGBV7YdzUGw3Hx1ce39x6mscdXJeak47iA';
                var chatId = '-247498799';
                
                axios.post('https://api.telegram.org/bot'+botApi+'/sendMessage?chat_id='+chatId+'&text='+text);
            },getImageUrl(name) {
                // const path = `/src/assets/img/${name}`;
                // const modules = import.meta.globEager('/src/assets/img/');
                // return modules[path].default
                return new URL(`/src/assets/img/${name}`, import.meta.url).href
            }
        }
    }
}